module.exports = __webpack_public_path__ + "img/gray-chevron-down-20x20.ec1d66a1.svg";